// PD-30386: pure translation from EditForm's Form#childAttributes contract
// (`name`, `value`, `handleChange(name, value)`) to the event shape each
// ideon-ui control speaks. Deliberately not React components -- a control we
// have not touched yet usually needs no new wrapper, just the matching
// adapter spread onto it.

// Serves any control with a plain DOM `onChange` event -- Input, Textarea,
// CurrencyInput, SearchInput.
export function toInputProps({ name, value, handleChange }) {
  return {
    value: value ?? '',
    onChange: (event) => handleChange(name, event.target.value)
  }
}

// Serves Switch and Checkbox -- both are Radix `checked`/`onCheckedChange`.
export function toToggleProps({ name, value, handleChange }) {
  return {
    checked: !!value,
    onCheckedChange: (checked) => handleChange(name, checked)
  }
}

// Serves Select and SegmentedControl. Radix Select's value is always a
// string, but a form field can be backed by a non-string type (e.g.
// `state_id` is an integer) -- without `cast`, picking an option would write
// back "3" where the record held 3. Pass `cast: Number` for an integer-backed
// field; a string-backed field (product_line, plan_audience) needs none.
export function toSelectProps({ name, value, handleChange }, { cast } = {}) {
  return {
    value: value == null ? '' : String(value),
    onValueChange: (stringValue) => handleChange(name, cast ? cast(stringValue) : stringValue)
  }
}

// Serves AsyncSearchSelect and MultiSelect -- controls whose onChange hands
// back a whole `{ value, label }` option rather than a primitive. The form
// only ever persists the id.
export function toOptionProps({ name, handleChange }) {
  return {
    onChange: (option) => handleChange(name, option ? option.value : null)
  }
}
